/* Copied from prototype/contact.html by tools/port-page.py. */
(function () {
  "use strict";

  /* The bar's cup still says which model you are in, the same as on every other
     page. It reads the visit's own model and falls back to OKKO, the studio's
     best seller, exactly as the home page does - this page keeps no copy of its
     own, so the two cannot drift. */
  var name = 'OKKO';
  try {
    var saved = sessionStorage.getItem('odaka.model');
    if (saved) name = saved;
  } catch (e) {}

  document.getElementById('forms-mark').innerHTML = window.ODAKA_SIL(name);
  document.getElementById('forms-btn').href =
    '/?screen=explore&m=' + window.ODAKA_SLUG(name);

  /* The footer's tally is written by the footer itself (sections/footer.liquid),
     from Shopify, 31-10-2026. */
})();


/* ⚠️ NOTHING IS SENT AND NOTHING IS STORED, the same warning as the footer's
   signup. The prototype has no server, so this validates, thanks you and
   forgets. In the theme it becomes Shopify's own contact form, which mails
   hello@odakahome.com, and this script goes away.

   ⚠️ And it is appended to the END OF THE FILE, not before </body>: these
   pages have no closing body tag, so an insert keyed to one does nothing at
   all and the form submits natively, which looks like the page reloading
   itself. Found 20 Sep 2026, the same hour the page was built. */
(function () {
  "use strict";
  var form = document.getElementById('ask');
  if (!form) return;
  var said = document.getElementById('ask-said');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var bad = ['ask-name', 'ask-mail', 'ask-note'].filter(function (id) {
      var f = document.getElementById(id);
      return !f.value.trim() || !f.checkValidity();
    });
    if (bad.length) {
      said.textContent = 'We need a name, an address we can answer, and a line about what you need.';
      said.hidden = false;
      document.getElementById(bad[0]).focus();
      return;
    }
    Array.prototype.forEach.call(form.querySelectorAll('label, .field, .send'), function (el) {
      el.hidden = true;
    });
    said.textContent = 'Thank you. We will write back.';
    said.hidden = false;
    /* The postmark is stamped now, with today's date: sending is the moment, David
       27-10-2026. On a phone the envelope is below the form, so it is brought into view. */
    var mark = document.getElementById('mark');
    if (mark) {
      mark.toggleAttribute('hidden', false);
      mark.classList.remove('stamped');
      void mark.getBBox();
      mark.classList.add('stamped');
    }
    var sent = document.querySelector('.sent');
    if (sent && sent.offsetParent) sent.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();


/* The letter: the name and country typed into the form are written on the
   envelope as they are typed, and the country's stamp lands with a postmark
   carrying the country and today's date. David, 10-10-2026. Four countries
   have their own stamp; anything else typed gets the house stamp. */
(function () {
  "use strict";
  var nameIn = document.getElementById('ask-name');
  var landIn = document.getElementById('ask-land');
  var fromName = document.getElementById('from-name');
  var fromLand = document.getElementById('from-land');
  var stamp = document.getElementById('stamp');
  var stampImg = document.getElementById('stamp-img');
  var mark = document.getElementById('mark');
  if (!nameIn || !landIn || !stamp) return;

  var LANDS = {
    israel: ['israel', 'ישראל', 'il', 'isr'],
    usa: ['usa', 'us', 'u s', 'u s a', 'united states', 'united states of america', 'america'],
    canada: ['canada', 'ca'],
    england: ['england', 'uk', 'u k', 'united kingdom', 'great britain', 'britain', 'gb']
  };
  var MONTHS = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
  var BOX = 250; /* the sender lines' width on the envelope, in painting units */

  function key(s) { return s.toLowerCase().replace(/[.\-_,]/g, ' ').replace(/\s+/g, ' ').trim(); }
  function stampFor(s) {
    var k = key(s);
    for (var land in LANDS) if (LANDS[land].indexOf(k) !== -1) return land;
    return 'default';
  }
  /* A long name shrinks to fit the lines rather than running off the paper. */
  function write(el, s) {
    el.textContent = s;
    el.removeAttribute('textLength');
    el.removeAttribute('lengthAdjust');
    if (s && el.getComputedTextLength() > BOX) {
      el.setAttribute('textLength', BOX);
      el.setAttribute('lengthAdjust', 'spacingAndGlyphs');
    }
  }

  var d = new Date();
  document.getElementById('mark-date').textContent =
    ('0' + d.getDate()).slice(-2) + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();

  /* The house stamp, on the envelope from the start, David 27-10-2026: one of the houses at
     random. Only one is painted so far; more go in this list. */
  var HOUSES = ['default'];
  var corner = HOUSES[Math.floor(Math.random() * HOUSES.length)];
  var house = document.getElementById('house-img');
  if (house) house.setAttribute('href', window.ODAKA_ASSET('contact-stamp-' + corner + '.webp'));

  /* The writing follows every keystroke; the country's stamp waits until the country is
     finished, David 27-10-2026: when the visitor leaves the field or presses return. A country
     without its own stamp gets a second house, a different one from the corner's when there is
     more than one. A house is wider than a country stamp, so it sits further left. */
  var current = null;
  function update() {
    write(fromName, nameIn.value.trim());
    var land = landIn.value.trim();
    write(fromLand, land.toUpperCase());
    document.getElementById('mark-land').textContent = land.toUpperCase().slice(0, 16);
    if (!land) { stamp.toggleAttribute('hidden', true); current = null; }
  }
  function stampIt() {
    var land = landIn.value.trim();
    var which = land ? stampFor(land) : null;
    if (!which) { stamp.toggleAttribute('hidden', true); current = null; return; }
    if (which === current) return;
    current = which;
    var file = which, wh = [122, 160], x = 622, y = 1342;
    if (which === 'default') {
      var others = HOUSES.filter(function (h) { return h !== corner; });
      file = others.length ? others[Math.floor(Math.random() * others.length)] : corner;
      wh = [154, 144]; x = 590; y = 1352;
    }
    stampImg.setAttribute('href', window.ODAKA_ASSET('contact-stamp-' + file + '.webp'));
    stampImg.setAttribute('width', wh[0]);
    stampImg.setAttribute('height', wh[1]);
    stampImg.setAttribute('x', x);
    stampImg.setAttribute('y', y);
    stampImg.setAttribute('transform', 'rotate(4 ' + x + ' ' + y + ')');
    /* SVG elements have no .hidden property, so the attribute is set directly. */
    stamp.toggleAttribute('hidden', false);
    stamp.classList.remove('lands');
    void stamp.getBBox();
    stamp.classList.add('lands');
  }
  nameIn.addEventListener('input', update);
  landIn.addEventListener('input', update);
  landIn.addEventListener('change', stampIt);
  landIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); stampIt(); landIn.blur(); } });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
  update();
})();

/* The frame follows the painting: 2025 x 1350 for the desktop desk from 1024px, the 1695 x 1980
   portrait below. CSS cannot change a viewBox, so this does. David, 24-10-2026. */
(function () {
  var svg = document.querySelector('.letter svg');
  if (!svg || !window.matchMedia) return;
  var mq = window.matchMedia('(min-width: 1024px)');
  function fit() { svg.setAttribute('viewBox', mq.matches ? '0 0 2025 1350' : '0 0 1695 1980'); }
  fit();
  if (mq.addEventListener) mq.addEventListener('change', fit); else mq.addListener(fit);
})();

/* The diary's year, written out, David 27-10-2026: "20" and "26" around the moka pot and "TWO
   THOUSAND & TWENTY SIX" at the foot, for whatever year it is, so the diary is never last year's.
   Liquid writes the numbers when the page is made; this sets all three from the visitor's clock. */
(function () {
  var c = document.getElementById('diary-century');
  var y = document.getElementById('diary-year');
  var w = document.getElementById('diary-words');
  if (!c || !y || !w) return;
  var ONES = ['', 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT', 'NINE', 'TEN',
    'ELEVEN', 'TWELVE', 'THIRTEEN', 'FOURTEEN', 'FIFTEEN', 'SIXTEEN', 'SEVENTEEN', 'EIGHTEEN', 'NINETEEN'];
  var TENS = ['', '', 'TWENTY', 'THIRTY', 'FORTY', 'FIFTY', 'SIXTY', 'SEVENTY', 'EIGHTY', 'NINETY'];
  function below100(n) { return n < 20 ? ONES[n] : TENS[Math.floor(n / 10)] + (n % 10 ? ' ' + ONES[n % 10] : ''); }
  function set() {
    var year = new Date().getFullYear(), rest = year % 100;
    c.textContent = String(year).slice(0, 2);
    y.textContent = String(year).slice(2);
    w.textContent = ONES[Math.floor(year / 1000)] + ' THOUSAND' + (rest ? ' & ' + below100(rest) : '');
  }
  set();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) set(); });
})();
